const searchElements = {
  initialize() {
    this.input = $('input[name="search"]');
    this.parent = $('.search-parent');
    this.childSelectorPrefix = '.search-item';

    this.setEventListeners();
  },
  setEventListeners() {
    $(this.input).keyup(e => {
      const filter = $(e.currentTarget).val();
      if (filter) {
        this.parent.find(`${this.childSelectorPrefix}:icontains("${filter}")`).show();
        this.parent.find(`${this.childSelectorPrefix}:not(:icontains("${filter}"))`).hide();
      } else {
        this.parent.find(this.childSelectorPrefix).show();
      }
    });
  },
};

export default function () {
  // on load
  searchElements.initialize();
}



// WEBPACK FOOTER //
// ./static-pages/search_elements.js